import _ from 'lodash';
import React from 'react';

import StatusBox from 'components/StatusBox';
import ButtonDropdown from 'components/ButtonDropdown';
import ExternalLink from 'components/ExternalLink';

import {formatDate} from 'utils/datetime';

import ArrowDelimiter from './assets/enlarge-horizontal.svg';
import './styles.css';

const BaseInformation = ({
  creditNote,
  voidCreditNote,
  addXeroIdToCreditNote,
  syncCreditNoteWithXero,
  deallocateCreditNoteFromInvoice,
  canBeDeallocated
}) => (
  <div className="BaseInformation">
    <div className="data">
      <div className="section">
        <div className="header">To</div>
        <div className="text">{creditNote.tenant.fullName}</div>
      </div>
      <div className="section">
        <div className="header">Date</div>
        <div className="text">{formatDate(creditNote.date)}</div>
      </div>
      <div className="section">
        <div className="header">Credit note NO</div>
        <div className="text">{creditNote.idString}</div>
      </div>

      <div className="section">
        <div className="header">Account</div>
        <div className="text">{`${creditNote.xeroAccount.code} - ${
          creditNote.xeroAccount.name
        }`}</div>
      </div>

      <div className="section">
        <div className="header">Rent Period</div>
        <div className="text colab-centered-v">
          <div>{formatDate(creditNote.rentStart)}</div>
          <img src={ArrowDelimiter} alt="Arrow delimiter" />
          <div>{formatDate(creditNote.rentEnd)}</div>
        </div>
      </div>

      <div className="section">
        <div className="header">Xero Status</div>
        <div className="text">
          {creditNote.xeroId ? (
            <ExternalLink
              className="xeroLink"
              href={creditNote.xeroLink}
              targetBlank>
              {creditNote.xeroNumber} →
            </ExternalLink>
          ) : (
            <StatusBox color={StatusBox.RED} status="Not synced" />
          )}
        </div>
      </div>
    </div>
    <div className="options">
      <ButtonDropdown title="Credit note options" className="scheduleOptions">
        <ButtonDropdown.Option
          disabled={canBeDeallocated}
          onClick={deallocateCreditNoteFromInvoice}>
          Deallocate From Invoice
        </ButtonDropdown.Option>
        <ButtonDropdown.Option
          disabled={!creditNote.isVoidable}
          onClick={voidCreditNote}>
          Void
        </ButtonDropdown.Option>
        <ButtonDropdown.Option
          disabled={!creditNote.isSyncable}
          onClick={syncCreditNoteWithXero}>
          Sync with Xero
        </ButtonDropdown.Option>
        <ButtonDropdown.Option
          disabled={creditNote.xeroId}
          onClick={addXeroIdToCreditNote}>
          Add Xero ID
        </ButtonDropdown.Option>
      </ButtonDropdown>
    </div>
  </div>
);

export default BaseInformation;
